// Sin fila de acciones de ActionDialog: el fondo necesita su propio aire
export const contentStyle = {
  paddingBottom: 32
}
